import { createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import { checkFinish, getPosibleMoves } from './gameAPI';

const initialState = {
    game: [
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0]],
    turn: 'b',
    lastMove: 0,
    finished: false,
    possibleMoves: [1, 1, 1, 1, 1, 1, 1]
}

export const checkMove = createAsyncThunk(
    'game/checkMove',
    async ({board, lastMove, turn}) =>{
        const finished = await checkFinish(board, lastMove, turn);
        return finished;
    }
);

export const checkMoves = createAsyncThunk(
    'game/checkMoves',
    async (board) =>{
        const possibleMoves = await getPosibleMoves(board);
        return possibleMoves;
    }
);

export const gameSlice = createSlice({
    name: 'game',
    initialState,
    reducers: {
        move: (state, action) => {
            const col = state.game[action.payload - 1];
            const turn = state.turn;

            for (let i = 0; i < 6; i++) {
                if (col[i] === 0) {
                    col[i] = turn;
                    break;
                }
            }
            state.lastMove = action.payload;
        },
        changeturn: (state) => {
            state.turn = state.turn === 'r' ? 'b' : 'r';
        },
        endgame: (state) => {
            state.finished = true;
        },
        newGame: () => initialState,
    },
    extraReducers: (builder) => {
        builder
        .addCase(checkMove.pending, (state) => {
            state.status = 'loading';
          })
        .addCase(checkMove.fulfilled, (state, action)=>{
            state.status = 'idle';
            state.finished = action.payload;
        })
        .addCase(checkMoves.pending, (state)=>{
            state.status = 'loading';
        })
        .addCase(checkMoves.fulfilled, (state, action)=>{
            state.status = 'idle';
            state.possibleMoves = action.payload;
        })
    }
});

export const { move, changeturn, endgame, newGame } = gameSlice.actions;

export const selectGame = (state) => state.game.game;
export const selectMoves = (state) => state.game.possibleMoves;
export const selectTurn = (state) => state.game.turn;
export const selectLastMove = (state) => state.game.lastMove;
export const finished = (state) => state.game.finished;

export default gameSlice.reducer;